import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { ConfigurationService } from '../../configuration.service';
import { AppConst } from '../../app-const';

@Injectable({
  providedIn: 'root'
})
export class NoBoardThreadGuard  {

  constructor(
    private router: Router,
    private configurationService: ConfigurationService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      let result: boolean = false;
      if (!!this.configurationService.getThreadId()) {
        result = true;
      } else {
        this.router.navigate([AppConst.ROUTING_LINK_TOP]);
      }
      return result;
  }

}
